import moment from 'moment';
import { MomentInstance as JsComponentMomentInstance } from '@mapado/js-component';
import { MomentInstance as SeatingMomentInstance } from '@mapado/seating';
import { MomentInstance as TicketingSdkMomentInstance } from '@mapado/ticketing-js-sdk';

// eslint-disable-next-line import/prefer-default-export
export function configureMoment(): void {
  moment.locale('fr');

  TicketingSdkMomentInstance.setMoment(moment);
  JsComponentMomentInstance.setMoment(moment);
  SeatingMomentInstance.setMoment(moment);
}
